/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_NextInputs */

const cs_calendar_next = /** @type {(inputs: Calendar_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Následující období`)
};

const en_calendar_next = /** @type {(inputs: Calendar_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next period`)
};

/**
* | output |
* | --- |
* | "Next period" |
*
* @param {Calendar_NextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_next = /** @type {((inputs?: Calendar_NextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_NextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_next(inputs)
	return cs_calendar_next(inputs)
});